import { Container, Toolbar } from '@mui/material';
import type { ContainerProps } from '@mui/material';
import type { ComponentProps } from 'react';
import { theme } from '@tbd/lift-ui/mui';

export function ContentContainer({
  children,
  component = 'main',
  sx,
  ...restProps
}: ContainerProps) {
  return (
    <Container
      sx={{
        [theme.breakpoints.down('md')]: {
          paddingX: 4,
        },
        [theme.breakpoints.up('md')]: {
          paddingX: 8,
        },
        ...(sx || {}),
      }}
      component={component}
      maxWidth="xl"
      {...restProps}
    >
      {children}
    </Container>
  );
}

export function BottomToolbar({
  children,
  ...restProps
}: ComponentProps<typeof Toolbar>) {
  return (
    <ContentContainer>
      <Toolbar disableGutters {...restProps}>
        {children}
      </Toolbar>
    </ContentContainer>
  );
}
